import React from 'react';
import { FileDownloadIcon } from '../../icons-new/file-download';
import IconHover from '../../icon-hover';

const DownloadExcelFile = () => {
  return <div></div>;
  // return (
  //   <IconHover>
  //     <FileDownloadIcon width={28} height={26} />
  //   </IconHover>
  // );
};

export default DownloadExcelFile;
